import  launchPermitApi from '@/services/launchPermitApi.js';
import  estoreAPI from '@/services/estoreServiceAPI.js';

const appError = {
  applicationError: {
    hasError: true,
    error: [
      "Application server has encountered an error, please try again later or call support"
    ]
  }
};


export default {
  healthCheck: ({ dispatch }) =>  {
    dispatch("estoreHealthCheck");    
  },
  estoreHealthCheck: ({ commit, dispatch }) =>  {
    commit('setLoading', true);
    commit('setErrors', null);
    try {
       estoreAPI.healthCheck()
        .then(response => {
          if (response && response.status === 200) {            
            dispatch("serviceHealthCheck");
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            appError.hasError = true;
            appError.applicationError.error = ["This service is temporarily unavailable. Please try again shortly."];
            commit("setErrors", appError);
          }
        });
    } catch (e) {
      appError.hasError = true;
      commit('setErrors', appError);
    } finally {
      commit('setLoading', false);
    }
  },  
  serviceHealthCheck: ({ commit, dispatch }) =>  {
    commit('setLoading', true);
    commit('setErrors', null);
    try {
       launchPermitApi.healthCheck()
        .then(response => {
          if (response && response.status === 200) {            
            dispatch("fetchConfiguration");
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            appError.hasError = true;
            appError.applicationError.error = ["This service is temporarily unavailable. Please try again shortly."];
            commit("setErrors", appError);
          }
        });
    } catch (e) {
      appError.hasError = true;
      commit('setErrors', appError);
    } finally {
      commit('setLoading', false);
    }
  },
  async fetchConfiguration({ commit }) {
      commit('setLoading', true);
      commit('setErrors', null);
      try {
        const res = await launchPermitApi.fetchConfiguration();
        commit('setConfiguration', res);
        
      } catch (e) {
        appError.hasError = true;
        commit('setErrors', appError);
      } finally {
        commit('setLoading', false);
      }
  },
  async fetchProductClass({ commit }, classId) {
      commit('setLoading', true);
      commit('setErrors', null);
      try {
        const res = await estoreAPI.fetchProductDetails(classId);
        commit('setEstoreClass', res);
      } catch (e) {
        appError.hasError = true;
        commit('setErrors', appError);
      } finally {
        commit('setLoading', false);
      }
  },
  async submit({ commit }, payload) {
    commit('setLoading', true);
    commit('setErrors', null);
    try {
      const res = await launchPermitApi.submit(payload);
      commit('setData', res.data ?? res);
    } catch (e) {
      appError.hasError = true;
      commit('setErrors', appError);
    } finally {
      commit('setLoading', false);
    }
  }
};